/**
 * Share-target plumbing for the PWA.
 *
 * The gateway "/share" endpoint stores any shared files as workspace
 * attachments and 303-redirects to "#/share?...". The share page (Share.jsx)
 * reads that query and sends a message to the currently open session (or a new
 * session) with the shared content, then navigates to the session page.
 *
 * Open-session tracking: the session page records the id it is viewing (or
 * clears it) so a fresh share-target page load knows whether a session is open
 * and can send the shared item to that session instead of creating a new one.
 */
const OPEN_SESSION_KEY = 'talos:openSession';

export function setOpenSession(id) {
  try {
    if (id) localStorage.setItem(OPEN_SESSION_KEY, id);
    else localStorage.removeItem(OPEN_SESSION_KEY);
  } catch {
    /* ignore */
  }
}

export function getOpenSession() {
  try {
    return localStorage.getItem(OPEN_SESSION_KEY) || null;
  } catch {
    return null;
  }
}